import { authGet } from './authMiddleware';

export const getPropertyProfile = async (id) => {
    return authGet(`api/Property?PropertyId=${id}`);
}